import React from 'react';
import cx from 'classnames';

import './tooltip.css';

/**
 * Displays a box that hovers near a trigger to provide contextual information. Leaves management
 * of the open / closed state of the tooltip to its parent component.
 * @param {TooltipProps} props
 */
export const ControlledTooltip = ({
    addOffset = true,
    background = 'dark',
    children,
    messageClasses,
    maxWidth = 200,
    message,
    minWidth = 200,
    position = 'top',
}: ControlledTooltipProps): JSX.Element => {
    const style = addOffset
        ? {
              [position]: -10, // add space between children and rendered tooltip
          }
        : undefined;

    return (
        <span className="tooltip relative" style={style}>
            <div
                className={cx(
                    `tooltip-bubble absolute z-10 tooltip-${position}`,
                    background,
                )}
                style={{
                    minWidth,
                    maxWidth,
                }}
            >
                <div
                    className={cx(
                        'tooltip-message rounded-md text-sm leading-snug p-3 break-words',
                        background,
                        messageClasses,
                    )}
                >
                    {message}
                </div>
            </div>
            {children && <>{children}</>}
        </span>
    );
};
